export enum OfferingType {
  APPLICATION = 'Software application',
  PLATFORM = 'Platform',
  SOLUTION = 'Solution',
  PROFESSIONAL_SERVICE = 'Professional service',
  INFRASTRUCTURE = 'Infrastructure',
}
